// extracted by mini-css-extract-plugin
export default {"parent_single":"SingleProductPage_parent_single__LwNCd","single_div_img":"SingleProductPage_single_div_img__GVDXD","buy_now":"SingleProductPage_buy_now__FUlkA"};